import React, { useState } from 'react';
import {
  Button,
  FormHelperText,
  Icon,
  InputAdornment,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core';
import useStyles from '../styles';


const DataMappingSearchBar = ({onSearch, searchFields, filters = {}}) => {
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState('');
  const [searchField, setSearchField] = useState('product_catalog_name');
  const filteredFields = Object.keys(filters);

  return (
    <div className="flex-column w-full">
      <div className="flex items-center w-full">
        <TextField
          variant="outlined"
          className={`min-w-300 text-primary ${classes.bgBlue} ${classes.customSearch}`}
          name="search-value"
          placeholder="Search"
          value={searchValue}
          onChange={(event) => setSearchValue(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !!searchField) {
              event.preventDefault();
              onSearch(searchValue, searchField);
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {!searchValue.length ?
                  <Icon color="primary">search</Icon>
                  :
                  <Icon
                    color="primary"
                    className="cursor-pointer"
                    onClick={() => {
                      setSearchValue(() => '');
                      onSearch('', '');
                    }}
                  >
                    close
                  </Icon>
                }
              </InputAdornment>
            )
          }}
        />
        <TextField
          select
          variant="outlined"
          className={`w-full min-w-220 text-primary ${classes.bgBlue} ${classes.customSearchField}`}
          name="search-field"
          value={searchField}
          onChange={(event) => setSearchField(event.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">by</InputAdornment>
            )
          }}
        >
          {searchFields.map(({name, value}) => {
            if (filteredFields.includes(value)) { //hide already filter fields through API to avoid wrong response
              return null;
            }

            return (
              <MenuItem value={value} key={value}>{name}</MenuItem>
            );
          })}
        </TextField>
        <Button
          color="primary"
          variant="contained"
          className={`mx-3 min-w-112 min-h-40 ${classes.toolbarButtonGutters}`}
          onClick={() => onSearch(searchValue, searchField)}
        >
          <Icon className="mr-2">search</Icon>
          <span className="uppercase">Search</span>
        </Button>
      </div>
      {!!searchValue.length &&
        <FormHelperText className={classes.helperText}>
          <Typography variant="caption">
            Press &apos;Enter&apos; to search
          </Typography>
        </FormHelperText>
      }
    </div>
  );
};

export default DataMappingSearchBar;
